import { render } from "./SvgIcon.vue?vue&type=template&id=3be0cd95&scoped=true&ts=true"
import script from "./SvgIcon.vue?vue&type=script&lang=ts"
export * from "./SvgIcon.vue?vue&type=script&lang=ts"

import "./SvgIcon.vue?vue&type=style&index=0&id=3be0cd95&lang=scss&scoped=true"

import exportComponent from "/root/workspace/sso-webclient_Xaij/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3be0cd95"]])

export default __exports__